var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['page fill-height', { responsivePage: !_vm.isWideScreen }]},[_c('VContainer',{staticClass:"page__container fill-height",attrs:{"fluid":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }